import { render, staticRenderFns } from "./ModalVisualizaPontoTarefa.vue?vue&type=template&id=3d9dab82"
import script from "./ModalVisualizaPontoTarefa.vue?vue&type=script&lang=js"
export * from "./ModalVisualizaPontoTarefa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports